module.exports = __webpack_public_path__ + "static/media/privacyPolicy.1fc93798.pdf";